import { popStateDetected, isExitingEstate } from './ui.state';

export function getPopStateDetected(): boolean {
  return popStateDetected.value;
}

export function getIsExitingEstate(): boolean {
  return isExitingEstate.value;
}
